import { render, staticRenderFns } from "./AlertEmails.vue?vue&type=template&id=57e10006&"
import script from "./AlertEmails.vue?vue&type=script&lang=js&"
export * from "./AlertEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports